import Axios from "axios";

class getVehicleViews {
    constructor(el) {
        this.DOM = { el: el };
        this.vehicleId = this.DOM.el.dataset.getViews;
        this.postUrl = this.DOM.el.dataset.postUrl;

        this.initEvents();
    }

    initEvents() {
        document.addEventListener("DOMContentLoaded", () => this.requestViews());
    }

    async requestViews() {
        const timeStamp = this.getTimeStamp();

        try {
            const { data } = await Axios.post(this.postUrl, {
                vehicleId: this.vehicleId,
                ...timeStamp
            });

            if (data.views) {
                this.insertViews(data.views);
            }

            if (data.timeStamp) {
                this.saveTimeStamp(data.timeStamp);
            }
        } catch (error) {
            this.insertViews(0);
            throw new Error(error);
        }
    }

    insertViews(views) {
        this.DOM.el.innerHTML = views;
    }

    saveTimeStamp(timeStamp) {
        localStorage.setItem(`timeStamp: ${this.vehicleId}`, timeStamp);
    }

    getTimeStamp() {
        const timeStamp = localStorage.getItem(`timeStamp: ${this.vehicleId}`);

        if (timeStamp !== null) {
            return { timeStamp: timeStamp };
        }
    }
}

const viewsNode = document.querySelector("[data-get-views]");
if (viewsNode !== null) {
    new getVehicleViews(viewsNode);
}
